import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Seo from '../Seo';
import SandoogLogo from '../atoms/SandoogLogo';
import routes from '../../setup/consts/routes';
import {
  PublicScrollUnlock,
  StyledPublicBack,
  StyledPublicFooter,
  StyledPublicFooterInner,
  StyledPublicFooterLinks,
  StyledPublicHeader,
  StyledPublicMain,
  StyledPublicRoot,
} from './styles';

interface PublicShellProps {
  seoTitle: string;
}

const PublicShell: React.FC<PublicShellProps> = ({ seoTitle, children }) => (
  <StyledPublicRoot>
    <PublicScrollUnlock />
    <Seo title={seoTitle} />

    <StyledPublicHeader>
      <Link to={routes.SIGN_IN} aria-label='Sandoog Center'>
        <SandoogLogo size={34} withText />
      </Link>
      <StyledPublicBack to={routes.SIGN_IN}>
        <FormattedMessage id='public.backToSignIn' defaultMessage='Back to sign in' />
      </StyledPublicBack>
    </StyledPublicHeader>

    <StyledPublicMain>{children}</StyledPublicMain>

    <StyledPublicFooter>
      <StyledPublicFooterInner>
        <span>
          <FormattedMessage
            id='login.copyright'
            defaultMessage='© {year} Sandoog'
            values={{ year: new Date().getFullYear() }}
          />
        </span>
        <StyledPublicFooterLinks>
          <Link to={routes.STATUS}>
            <FormattedMessage id='login.footerStatus' defaultMessage='Status' />
          </Link>
          <Link to={routes.PRIVACY}>
            <FormattedMessage id='login.footerPrivacy' defaultMessage='Privacy' />
          </Link>
          <Link to={routes.TERMS}>
            <FormattedMessage id='login.footerTerms' defaultMessage='Terms' />
          </Link>
        </StyledPublicFooterLinks>
      </StyledPublicFooterInner>
    </StyledPublicFooter>
  </StyledPublicRoot>
);

export default PublicShell;
